import { cn } from "@/zapi-frontend/shared/lib/utils";
import { memoType } from "./memoTypography";

type TBlockLabelProps = {
  label?: string | null;
  className?: string;
};

export function BlockLabel({ label, className = "mb-3" }: TBlockLabelProps) {
  if (!label) return null;
  return <div className={cn(memoType.blockLabel, className)}>{label}</div>;
}
